import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";


const baseurl = process.env.REACT_APP_ONLINE_TRAINING

export const postTraining = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/Training/AddTraining`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response); 
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const trainingSchedule = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/Training/TrainingSchedule`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response); 
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}